import { Warning } from '@mui/icons-material'
import { Box, Link, Stack, Typography, styled } from '@mui/material'
import { type ReactNode } from 'react'

type LinkWithIconProps = {
  href: string
  icon: ReactNode
  error?: boolean
  children: ReactNode
  testId?: string
  trackId?: string
}

const LinkComponent = styled(Link, {
  name: 'LinkComponent',
})(() => ({
  '.external-link-icon-container': {
    display: 'none',
  },

  '&:hover': {
    '.external-link-icon-container': {
      display: 'inline-flex',
    },
  },
}))

export function LinkWithIcon(props: LinkWithIconProps) {
  const {
    href,
    icon,
    error = false,
    children,
    testId = 'integration-device-data',
    trackId = 'integration-device-data',
  } = props

  return (
    <LinkComponent
      href={href}
      target="_blank"
      color={error ? 'error' : undefined}
      data-trackid={trackId}
      data-testid={testId}
    >
      <Stack spacing={1} direction="row" alignItems="center">
        <Typography variant="body1">{children}</Typography>
        <Box display="inline-flex" className="external-link-icon-container">
          {icon}
        </Box>
        {error && (
          <Box display="inline-flex" className="icon-container">
            <Warning />
          </Box>
        )}
      </Stack>
    </LinkComponent>
  )
}
